import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { CreateOpportunityTaskRequest, OpportunityTask } from 'backend/types'
import { createOpportunityTask } from '@/lib'
import { queryKeys } from '@/lib/queryKeys'

interface UseCreateOpportunityTaskOptions {
  onSuccess?: (data: OpportunityTask) => void
  onError?: (error: Error) => void
}

export function useCreateOpportunityTask(opportunityId: number, options: UseCreateOpportunityTaskOptions = {}) {
  const { onSuccess, onError } = options
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: CreateOpportunityTaskRequest) => {
      return createOpportunityTask(opportunityId, data)
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.opportunity.tasks(opportunityId) })
      onSuccess?.(data)
    },
    onError: (error: Error) => {
      onError?.(error)
    },
  })
}
